
export  class MQTOptions {
    constructor(){
        this.mqt_questions = {};
        this.mqt_answers = {};
        this.mqt_question_answer_map = {};
        this.mqt_answer_header = false;
        this.mqt_hide_question = false;
        this.mqt_answer_count = 0;
        this.mqt_question_random_order = false;
        this.mqt_answers_random_order = false;
        this.mqt_answer_type = 'checkbox';
    }

    //Generates the MQT Options data from the API Response
    static CreateMQTFromApi(mqt_options){
        let mqtOptions = new MQTOptions();
        try{
            if(mqt_options){
                //Init mqt_questions
                if(mqt_options.mqt_questions){
                    mqtOptions.mqt_questions = mqt_options.mqt_questions;
                }
                mqtOptions.mqt_question_random_order = mqt_options.mqt_question_random_order;
                mqtOptions.mqt_answers_random_order = mqt_options.mqt_answers_random_order;
                mqtOptions.mqt_hide_question = mqt_options.mqt_hide_question;

                //Init mqt_answers
                mqtOptions.mqt_answer_count = mqt_options.mqt_answer_count;
                mqtOptions.mqt_answer_header = mqt_options.mqt_answer_header;

                if(mqtOptions.mqt_answer_header){
                    if(mqt_options.mqt_answers){
                        mqtOptions.mqt_answers = mqt_options.mqt_answers;
                    }
                }
                mqtOptions.mqt_question_answer_map = mqt_options.mqt_question_answer_map
                mqtOptions.mqt_answer_type = mqt_options.mqt_answer_type;
            }
        }catch(e){
            console.error(e);
            return null;
        }

        return mqtOptions;
    }

    
    static isAnswerCorrect = (mqt_options,selected_answers)=> {
        
        if(mqt_options){
            const {mqt_questions,mqt_question_answer_map,mqt_mastery_condition,mqt_answer_type} = mqt_options;
            let totalCorrectAnswers = 0; //Total Correct Question Block Count

            //Loop Through each Question
            Object.keys(mqt_questions).forEach(qID=>{
                
                const correct_answers = mqt_question_answer_map[qID];
                const user_selected_answers = selected_answers[qID];
                if(mqt_answer_type === 'checkbox'){
                    if(isAnswerCorrectCheckBox(correct_answers,user_selected_answers)){
                        totalCorrectAnswers++
                    }
                }else{
                    if(isAnswerCorrectRadio(correct_answers,user_selected_answers)){
                        totalCorrectAnswers++
                    }
                }
                
            });

            //If the total correct blocks are equal to or greater than minimum number of blocks required to be correct, then mark answer as correct.
            if(totalCorrectAnswers >= mqt_mastery_condition){
                return true;
            }
        }

        
        return false;
    } 
}


const isAnswerCorrectCheckBox = (correct_answers_str,selected_answers) => {
    const correct_answers = correct_answers_str.split(",");
    if(correct_answers && selected_answers){
        if(correct_answers.length === selected_answers.length){
                

            let correct_answer_count = 0 ;
            correct_answers.forEach(answer => {
                if(selected_answers.includes(answer)){
                    correct_answer_count ++;
                }
            })

            if(correct_answers.length === correct_answer_count){
                return true;
            }
            
        }
    }
}

const isAnswerCorrectRadio = (correct_answers_str,selected_answers) => {
    const correct_answers = correct_answers_str.split(",");
    if(correct_answers && selected_answers){
        for (const index in correct_answers) {
            if(selected_answers.includes(correct_answers[index])){
                return true;
            }
        }
        
    }

    return false;
}
